import React, { useState } from 'react';
import ReactTable from 'react-table'
import moment from 'moment'
import {deleteAddress, updateAddress} from '../../store/action/address';
import { isAuthenticated } from '../../store/action/auth';
import Modal from "../molecules/Modal";
import AddressForm from "../forms/AddressForm";
import { getGeocode } from "../../store/action/location";
import { trackEvent } from "../../services/analytics";

const { token } = isAuthenticated();

const AddressTable = props => {
    const [ modal, setModal ] = useState(false);
    const [ locLoading, setLocLoading ] = useState(false);
    const [ address, setAddress ] = useState({
      addressId:'',
      addressName:'',
      addressDetails:'',
      addressPIC:'',
      address:'',
      coordinate: {
          latitude:'',
          longitude:''
      },
      postalCode:0,
      provinceId:0,
      provinceName:'',
      cityId:0,
      cityName:'',
      districtId:0,
      districtName:'',
      subdistrictId:0,
      subdistrictName:'',
      mapAddress:'',
      stores:[]
    });

    const columns = [{
      Header: '#',
      Cell: ({row,original}) => row._index+1,
      maxWidth: 75,
      className:'text-center',
      headerClassName: 'text-center'
    },{
      Header: 'NAMA PENGIRIM',
      accessor: 'addressName', // String-based value accessors!
      Cell: ({row, original}) => nameCell(original)
    },{
      Header: 'NO TELPON',
      accessor: 'addressPIC', // String-based value accessors!
    },{
      Header: 'ALAMAT',
      accessor: 'addressDetails',
    },{
      Header: 'INFO LAINNYA',
      accessor: 'addressNote',
    },{
      Header: 'WAKTU DIBUAT',
      accessor: 'addressDetails',
      Cell: ({row,original}) => moment(row.createdAt).format('DD-MM-YYYY')
    },{
      Header: 'EDIT',
      maxWidth: 100,
      accessor: '_id',
      Cell: ({row,original}) => (
        <div className="actions ml-3">
          <a onClick={() => handleModalShow(original)} className="action-item mr-2" data-toggle="tooltip" title="Edit">
            <i className="fas fa-edit"></i>
          </a>
          <a onClick={() => onAddressDelete(original.addressId)} className="action-item mr-2" data-toggle="tooltip" title="Trash">
            <i className="fas fa-trash"></i>
          </a>
        </div>
      )
    }];

    const handleModalClose = () => {
        setModal(false)
    };

    const handleModalShow = (o) => {
        setModal(true);
        setAddress({
            ...address,
            ...o
        });
    };

    const nameCell = (o) => {
        let storeView;
        if (o.stores.length > 0 ){
            storeView = o.stores.map(i => (
                <span className={"badge badge-warning"}>
                    {i}
                </span>
            ))
        }
        return (
            <div>
                {o.addressName} {storeView}
            </div>
        )
    }

    const onStoreChange = stores => {
        setAddress({
            ...address,
            stores
        })
    };

    const handleChange = name => event => {
        setAddress({ ...address,
            error: false,
            success:false,
            [name]: event.target.value
        });
    };

    const onUpdateSubmit = async () => {
      try {
          const reducedStores = address.stores.reduce((r,i) => {
              r.push(i.value);
              return r
          },[]);

          let newAddress = {
              ...address,
              stores:reducedStores
          };

          const res = await updateAddress(token, address.addressId, newAddress);
          if (res.success) {
              trackEvent("Address Updated",{
                  action: "track",
                  category: "Addresses",
                  label: 'Update Existing Address',
                  event: "Click"
              });
              setModal(false);
              alert(`Alamat berhasil diedit`);
              props.onRefresh();
          } else {
              alert("Gagal mengedit alamat. Coba ulangi beberapa saat kembali :)")
          }
      } catch (err) {
          console.log(err)
          alert("Gagal update alamat")
      }
    };

    const onAddressDelete = (id) => {
    if(window.confirm('Kamu yakin mau hapus alamat?')) {
      deleteAddress(token, id, 0)
        .then(res => {
          if(res.success){
            alert(`Alamat berhasil dihapuus`);
            props.onRefresh();
          } else {
            alert("Tidak dapat menghapus alamat. Coba ulang kembali")
          }
        });
    }
    };

    const onLocationChange = ad => {
        setAddress({
            ...address,
            addressDetails:ad
        })
    };

    const onEditLocation = () => {
        setAddress({
            addressId: address.addressId,
            addressName: address.addressName,
            addressDetails: '',
            addressPIC: address.addressPIC,
            addressNote: address.addressNote,
            coordinate: {
                latitude:'',
                longitude:''
            },
            postalCode:0,
            provinceId:0,
            provinceName:'-',
            cityId:0,
            cityName:'-',
            districtId:0,
            districtName:'-',
            subdistrictId:0,
            subdistrictName:'-',
            stores:[]
        })
    };

    const onSelectLocation = async (a,c) => {
        setLocLoading(true);
        const res = await getGeocode(token, c);
        if (res.success){
            setAddress({
                ...address,
                error: false,
                success:false,
                addressDetails:a,
                coordinate:c,
                ...res.location
            })
        }
        setLocLoading(false);
    };

    const modalView = () => {
      return (
          <Modal
              show={modal}
              onHide={handleModalClose}
              title="Edit Alamat"
              bodyClassName="p-4"
              buttons
              type="yesno"
              lbText="Kembali"
              rbText="Simpan"
              lbClick={handleModalClose}
              rbClick={() => onUpdateSubmit()}
          >
              <AddressForm
                  handleChange={handleChange}
                  handleChangeLocation={onLocationChange}
                  handleChangeStore={onStoreChange}
                  onEditLocation={onEditLocation}
                  locationLoading={locLoading}
                  data={address}
                  onSelectLocation={onSelectLocation}
                  button={false}
              />
          </Modal>
      );
    };

    return (
    <div>
      { modalView() }
      <ReactTable
        data={props.data}
        columns={columns}
        defaultPageSize={10}
        filterable
        loading={props.loading}
        className="-striped -highlight"
      />
    </div>
    )
};

export default AddressTable;
